import { type QueryClient } from '@tanstack/react-query';
import { notFound } from '@tanstack/react-router';
import { BookingServices } from '@/api/services/booking';
import { type clusterService } from '@/api/services/cluster';
import { isClusterHybridCloud } from '@/utils/cluster-utils';

/**
 * Shared logic for inference route validation
 */
export async function resolveInference({
  queryClient,
  clusterQuery,
  accountId,
}: {
  queryClient: QueryClient;
  clusterQuery: ReturnType<typeof clusterService.getClusterQuery>;
  accountId: string;
}) {
  const { cluster } = await queryClient.fetchQuery(clusterQuery);
  const isHybridCloudCluster = isClusterHybridCloud(cluster);
  if (isHybridCloudCluster) {
    throw notFound();
  }

  const inferenceModelsQuery = BookingServices.listInferenceModelsQuery({
    accountId,
    cloudProviderId: cluster.cloudProviderId,
    cloudProviderRegionId: cluster.cloudProviderRegionId,
  });

  const { items: inferenceModels } = await queryClient.fetchQuery(inferenceModelsQuery);

  return { inferenceModels, inferenceModelsQuery };
}
